module.exports = __webpack_public_path__ + "static/coffeetalk2-41b6415a94683c79443a5a49194b0460.png";